import { store } from 'redux/store';
import { useCallback, useEffect, useState } from 'react';

import { getPartnerCategories } from 'modules/partners/redux/partnerCategoryActions';

type UsePartnerCategoriesProps = {
  societyId: string | undefined;
};

export const usePartnerCategories = ({
  societyId,
}: UsePartnerCategoriesProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchPartnerCategories = useCallback(async () => {
    if (!societyId) return;
    setIsLoading(true);
    setIsError(false);
    try {
      await store.dispatch(getPartnerCategories(societyId));
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }, [societyId]);

  useEffect(() => {
    fetchPartnerCategories();
  }, [fetchPartnerCategories]);

  return { isLoading, isError, actions: { fetchPartnerCategories } };
};
